/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  apiBaseUrl: 'https://kinglogi-api.techlead.vn/api/v2',
  firebase: {
    apiKey: "AIzaSyCW2iYtQbnmrWGHAD9qwUr7DlTvwSrRBXw",
    authDomain: "kinglogi-5a594.firebaseapp.com",
    databaseURL: "https://kinglogi-5a594.firebaseio.com",
    projectId: "kinglogi-5a594",
    storageBucket: "kinglogi-5a594.appspot.com",
    messagingSenderId: "816296051255",
    appId: "1:816296051255:web:6bc3129036c30f209335b2",
    measurementId: "G-89F770PDE7",
  },
  // mapKey: 'zaWwBwOCErxOeHiBmX2Wneqp7NCG411qXqcVef8y',
  mapKey: '9pNWl5xH0MfGcrn7ngf4RXzk3Z9TULYvfanReU2y'
};
